import { IAuthService } from '@lib/domain/user/interface';
import { IStreamingPalService } from '@lib/domain/streamingpal/interface';

import { HTTPService } from '@lib/infra/HTTPService/HTTPService';

import APP_CONFIG from '@lib/constants/APP_CONFIG';
import qs from 'qs';
import { Track } from '@lib/state/StreamingPals/types';
import {
    ResponseGetListArtist,
    ResponseGetProfileUser,
    ResponseGetListAlbum,
    PayloadGetListAlbum,
} from '@lib/domain/streamingpal';

interface Dependencies {
    httpService: HTTPService;
    authService: IAuthService;
}

let index = 0;

export class StreamingPalRepository implements IStreamingPalService {
    private authService: IAuthService;

    private httpService: HTTPService;

    constructor({ authService, httpService }: Dependencies) {
        this.authService = authService;
        this.httpService = httpService;
    }

    async getTokenAccess(): Promise<string> {
        const url = 'https://accounts.spotify.com/api/token';
        const data = qs.stringify({
            grant_type: 'client_credentials',
            client_id: APP_CONFIG.STREAMING_PAL.API_KEY[index].client_id,
            client_secret:
                APP_CONFIG.STREAMING_PAL.API_KEY[index].client_secret,
        });
        const res = await this.httpService.post({
            url,
            data,
            options: {
                headers: {
                    'Content-Type':
                        'application/x-www-form-urlencoded;charset=utf-8',
                },
            },
        });

        return res.data.access_token;
    }

    async FetchData(url: string): Promise<any> {
        if (index > APP_CONFIG.STREAMING_PAL.API_KEY.length - 1) {
            return { errorHttp: 'Limit api key' };
        }
        const token = await this.getTokenAccess();
        try {
            const res = await this.httpService.authGet({
                url,
                token,
            });
            return res.data;
        } catch (err) {
            if (
                err.message === `${APP_CONFIG.STREAMING_PAL.STATUS_RATE_LIMIT}`
            ) {
                index += 1;
            }
            return { errorHttp: err.message };
        }
    }

    async getListArtist(name: string): Promise<ResponseGetListArtist> {
        const url = `https://api.spotify.com/v1/search?q=${name}&type=artist&limit=${APP_CONFIG.QUERY_PAGE_SIZE}`;
        const res = await this.FetchData(url);
        const { artists } = res;
        let { errorHttp } = res;
        while (
            errorHttp &&
            errorHttp === `${APP_CONFIG.STREAMING_PAL.STATUS_RATE_LIMIT}`
        ) {
            // eslint-disable-next-line no-await-in-loop
            const response = await this.FetchData(url);
            errorHttp = response?.errorHttp;
        }
        if (artists) {
            return artists;
        }
        return res;
    }

    async getProfileUser(userId: string): Promise<ResponseGetProfileUser> {
        const url = `https://api.spotify.com/v1/artists/${userId}`;
        const res = await this.FetchData(url);
        let { errorHttp } = res;
        while (
            errorHttp &&
            errorHttp === `${APP_CONFIG.STREAMING_PAL.STATUS_RATE_LIMIT}`
        ) {
            // eslint-disable-next-line no-await-in-loop
            const response = await this.FetchData(url);
            errorHttp = response?.errorHttp;
        }
        return res;
    }

    async getListAlbum(
        req: PayloadGetListAlbum,
    ): Promise<ResponseGetListAlbum> {
        const url = `https://api.spotify.com/v1/artists/${req.userId}/albums?include_groups=${req.typeAlbum}&limit=${APP_CONFIG.QUERY_ALBUM_SIZE}&offset=${req.offset}`;
        const res = await this.FetchData(url);
        let { errorHttp } = res;
        while (
            errorHttp &&
            errorHttp === `${APP_CONFIG.STREAMING_PAL.STATUS_RATE_LIMIT}`
        ) {
            // eslint-disable-next-line no-await-in-loop
            const response = await this.FetchData(url);
            errorHttp = response?.errorHttp;
        }
        return res;
    }

    async getListTrackByAlbum(albumId: string): Promise<Track[]> {
        const url = `https://api.spotify.com/v1/albums?ids=${albumId}`;
        const res = await this.FetchData(url);
        let { errorHttp } = res;
        while (
            errorHttp &&
            errorHttp === `${APP_CONFIG.STREAMING_PAL.STATUS_RATE_LIMIT}`
        ) {
            // eslint-disable-next-line no-await-in-loop
            const response = await this.FetchData(url);
            errorHttp = response?.errorHttp;
        }
        const { albums } = res;
        if (albums.length > 0 && albums[0].tracks.items) {
            const items: Track[] = albums[0].tracks.items.map((item) => ({
                id: item.id,
                name: item.name,
                external_urls: item.external_urls,
            }));
            return items;
        }
        return [
            {
                id: '',
                name: '',
                external_urls: {
                    spotify: '',
                },
            },
        ];
    }

    async getListAlbumByLink(url: string): Promise<ResponseGetListAlbum> {
        const res = await this.FetchData(url);
        let { errorHttp } = res;
        while (
            errorHttp &&
            errorHttp === `${APP_CONFIG.STREAMING_PAL.STATUS_RATE_LIMIT}`
        ) {
            // eslint-disable-next-line no-await-in-loop
            const response = await this.FetchData(url);
            errorHttp = response?.errorHttp;
        }
        return res;
    }
    async getMaxAmount(): Promise<number> {
        const url = 'settings/max-amount';
        const res = await this.httpService.get({
            url,
        });
        return res.data;
    }
}
